import { Nav } from 'react-bootstrap';
import { NavItemWrapper, NavWrapper } from './styles';
import { PatientType } from '@nkr/enums/index';

interface IProps {
    activeKey: string,
    centerId: number,
    donorId: number,
    donorAlias?: string,
    donorIsAdp?: boolean,
    voucherHolderId?: number,
    voucherHolderName?: string,
    // pairedRecipientId: number,
    // pairedRecipientAlias: string,
    // voucherRecipientId: number,
    // voucherRecipientAlias: string,
    recipientId: number,
    recipientAlias: string,
    recipientCenterId: number,
    recipientType: PatientType,
    isAdminLogin: boolean,
    onTabChange: (tab: string) => void
}

const SwapDonorsNav = (props: IProps) => {
    let hrefBasePrefix = `/center/${props.centerId}`;
    let hrefPrefix = `${hrefBasePrefix}/donor/${props.donorId}`;

    return (
        <NavWrapper height='30px'>
            <div style={{ padding: 0, backgroundColor: 'white', marginBottom: props.donorId > 0 ? 20 : 0 }}>
                <Nav bsStyle='pills' className='swap-donor-pills'>
                    <NavItemWrapper active={props.activeKey == 'SWAP'} href={`/center/${props.centerId}/donors/swap`}>
                        List
                    </NavItemWrapper>

                    <li role='presentation' className='li-divider'><div className='pill-divider'></div></li>

                    <NavItemWrapper href={`/center/${props.centerId}/profile/cheek-swab-request`}>
                        Order Bulk Cheek Swabs
                    </NavItemWrapper>

                    <li role='presentation' className='li-divider'><div className='pill-divider'></div></li>

                    <NavItemWrapper active={props.activeKey == 'VOUCHER-PROGRAM'} href={`/center/${props.centerId}/donors/voucher-program`}>
                        Voucher Program
                    </NavItemWrapper>

                    <li role='presentation' className='li-divider'><div className='pill-divider'></div></li>

                    <NavItemWrapper active={props.activeKey == 'ADD'} href={hrefBasePrefix + '/donor/add'}>
                        Add
                    </NavItemWrapper>

                    {((props.recipientId > 0 && props.recipientCenterId == props.centerId) || (props.recipientId > 0 && props.isAdminLogin)) && (
                        <>
                            <li role='presentation' className='li-divider'><div className='pill-divider'></div></li>
                            <NavItemWrapper active={props.activeKey == 'VOUCHER-HOLDERS'} href={`/center/${props.recipientCenterId}/recipient/${props.recipientId}/profile/general`}>
                                Edit {props.recipientType == PatientType.StandardVoucherHolder || props.recipientType == PatientType.FamilyVoucherHolder ? 'Voucher' : ''} Recipient [{props.recipientAlias}]
                            </NavItemWrapper>
                        </>
                    )}

                    {props.activeKey == 'VOUCHER-HOLDER-EDIT' && (
                        <>
                            <li role='presentation' className='li-divider'><div className='pill-divider'></div></li>
                            <NavItemWrapper active={props.activeKey == 'VOUCHER-HOLDER-EDIT'} href={hrefPrefix + '/voucher-holder/' + props.voucherHolderId}>
                                Voucher Details [<span style={{ color: 'lightgray', fontWeight: 500 }}>{props.voucherHolderName}</span>]
                            </NavItemWrapper>
                        </>
                    )}


                    {props.donorId > 0 && (
                        <>
                            <li role='presentation' className='li-divider'><div className='pill-divider'></div></li>
                            <NavItemWrapper active={props.activeKey == 'EDIT'} href={`/center/${props.centerId}/donor/${props.donorId}/profile`}>
                                Edit Donor [{props.donorAlias}]
                        </NavItemWrapper>
                        </>
                    )}
                </Nav>
            </div>
        </NavWrapper>
    );
}

export default SwapDonorsNav;